import {
  ADD_ITEM_TO_CITIES_LIST,
  REMOVE_ITEM_FROM_CITIES_LIST,
  CLEAR_CITIES_LIST,
} from "../types";

export default function appCitiesList(state = {}, action = {}) {
  switch (action.type) {
    case ADD_ITEM_TO_CITIES_LIST: {
      let appCities = state.appCities;
      if (!appCities) appCities = {};
      appCities[action.cityData.cityKey] = action.cityData.cities;
      return { ...state, appCities };
    }
    case REMOVE_ITEM_FROM_CITIES_LIST: {
      let appCities = state.appCities;
      if (!appCities) appCities = {};
      if (Object.keys(appCities).includes(action.cityData.cityKey)) {
        delete appCities[action.cityData.cityKey];
      }
      return { ...state, appCities };
    }
    case CLEAR_CITIES_LIST: {
      return { ...state, appCities: {} };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appCitiesList.js